import { NEW_TRICK } from '../reducers/heartsTricks';
export const newTrick = () => ({
  type: NEW_TRICK
});



// WEBPACK FOOTER //
// ./src/actions/tricks.js